<template>
  <!-- 列表 -->
  <div class="header-content">
    <!-- 子级列表内容左标题 -->
    <div class="header-content-title">{{title}}</div>

    <slot />
  </div>
</template>

<script>
// import commonStyle from "../../common/style/vue/Style";

export default {
  // 名字
  name: "ItemHeader",
  // 参数
  props: {
    title: String,
  },
  // 生命周期 创建方法
  created() {},

  mounted() {
    // console.log('he -- ',this.$refs.title.style.height);
  },

  // 方法
  methods: {
    
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" rel="stylesheet/stylus" scoped >
/* 列表内容样式 */
@import '~@/common/style/styl/var';

.header-content {
  background: rgb(231, 231, 231);
  min-height: $rowheight-item;
  display: flex;
  flex-direction: row;
  /* 实现垂直居中 */
  align-items: center;
  background : $color-white;
  padding: $spacing-view-min 0;
}

.header-content-title {
  color: #000;
  padding-left : $spacing-view;
}

/* 最后数据样式 */
</style>